import React, { useEffect } from 'react';
import { Container } from './styles';

const Home: React.FC = () => {
  useEffect(() => {
    document.title = 'Home | Portal LGPD';
  }, []);

  return (
    <Container>
      <div className="content">
        <div className="image-country">
          <span>country</span>
        </div>
        <div className="welcome">
          <h2>Bem-Vindo</h2>
          <h1>Portal LGPD</h1>
        </div>
      </div>
    </Container>
  );
};

export default Home;
